import React, { useEffect, useState } from 'react';
import { Paper, Typography, Box, CircularProgress, LinearProgress, Chip, Tooltip } from '@mui/material';
import CategoryIcon from '@mui/icons-material/Category';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';

/**
 * Top 5 categorias por número de domínios.
 * Barras proporcionais. Click → detalhe.
 */
export default function TopCategoriesCard() {
    const navigate = useNavigate();
    const [state, setState] = useState({ loading: true, items: [] });

    useEffect(() => {
        api.get('/dashboard/oceanide/top_categories')
            .then((res) => setState({ ...res.data, loading: false }))
            .catch(() => setState({ loading: false, items: [] }));
    }, []);

    const max = Math.max(1, ...state.items.map((c) => c.count));

    return (
        <Paper
            elevation={2}
            sx={{
                m: 2,
                p: 2,
                minHeight: 280,
                display: 'flex',
                flexDirection: 'column',
                borderLeft: '4px solid #e01b29',
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <CategoryIcon color="primary" />
                <Typography variant="subtitle2" sx={{ textTransform: 'uppercase', fontWeight: 600 }}>
                    Top categorias por tamanho
                </Typography>
            </Box>

            {state.loading ? (
                <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <CircularProgress size={28} />
                </Box>
            ) : state.items.length === 0 ? (
                <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Typography variant="body2" color="text.secondary">
                        Nenhuma categoria cadastrada
                    </Typography>
                </Box>
            ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                    {state.items.map((c, i) => (
                        <Box
                            key={c.id}
                            onClick={() => navigate(`/dns_blacklist/category/${c.id}`)}
                            sx={{ cursor: 'pointer', p: 0.5, borderRadius: 1, '&:hover': { bgcolor: 'action.hover' } }}
                        >
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.25 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0 }}>
                                    <Typography variant="body2" sx={{ fontFamily: 'Montserrat', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {i + 1}. {c.name}
                                    </Typography>
                                    {!c.active && (
                                        <Tooltip title="Categoria inativa">
                                            <Chip size="small" label="inativa" variant="outlined" color="default" />
                                        </Tooltip>
                                    )}
                                </Box>
                                <Typography variant="body2" sx={{ color: c.active ? 'primary.main' : 'text.disabled', fontWeight: 600, ml: 1 }}>
                                    {c.count.toLocaleString('pt-BR')}
                                </Typography>
                            </Box>
                            <LinearProgress
                                variant="determinate"
                                value={Math.min(100, (c.count / max) * 100)}
                                sx={{
                                    height: 6,
                                    borderRadius: 3,
                                    bgcolor: '#f0f0f0',
                                    '& .MuiLinearProgress-bar': { bgcolor: c.active ? '#e01b29' : '#bdbdbd' },
                                }}
                            />
                        </Box>
                    ))}
                </Box>
            )}
        </Paper>
    );
}
